import {
  CreateTagApiArg,
  CreateTagApiResponse,
  DeleteTagApiResponse,
  DeleteTagsApiArg,
  ReadTagCategoriesApiResponse,
  Tag,
  UpdateTagActiveStateApiArg,
  UpdateTagActiveStateApiResponse,
  UpdateTagFavoriteArg,
  UpdateTagFavoriteResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

export const tagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readTagCategories: builder.query<ReadTagCategoriesApiResponse, void>({
      query: () => ({
        version: 1,
        path: 'tags/categories',
      }),
    }),
    createTag: builder.mutation<CreateTagApiResponse, CreateTagApiArg>({
      query: (body) => ({
        version: 1,
        method: 'POST',
        path: 'tags/conversation',
        body,
      }),
    }),
    updateTagActiveState: builder.mutation<
      UpdateTagActiveStateApiResponse,
      UpdateTagActiveStateApiArg
    >({
      query: ({ tag, isActive }) => ({
        version: 1,
        method: 'PATCH',
        path: `tags/${tag.id}/${isActive ? 'activate' : 'deactivate'}`,
      }),
    }),
    updateTagFavoriteState: builder.mutation<
      UpdateTagFavoriteResponse,
      UpdateTagFavoriteArg
    >({
      query: ({ tag, isFavorite }) => ({
        version: 1,
        method: 'PATCH',
        path: `tags/${tag.id}/${isFavorite ? 'favorite' : 'unfavorite'}`,
      }),
      async onQueryStarted({ tag, isFavorite }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          tagsApi.util.updateQueryData(
            'readTagCategories',
            undefined,
            (draft) => {
              const favoriteCategory = draft.data.categories.find(
                ({ id }) => id === 'favorite',
              );

              if (favoriteCategory) {
                const tags = favoriteCategory.items as Tag[];

                if (isFavorite) {
                  tags.push(tag);
                } else {
                  tags.splice(
                    tags.findIndex(({ id }) => id === tag.id),
                    1,
                  );
                }
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    deleteTag: builder.mutation<DeleteTagApiResponse, DeleteTagsApiArg>({
      query: ({ id }) => ({
        version: 1,
        method: 'DELETE',
        path: `tags/conversation/${id}`,
      }),
    }),
  }),
});
